import './StatusPill.styl';

import { useTranslation } from 'react-i18next';

import { STATUS_TONE, type PillStatus } from './status';

export type { PillStatus, WorkloadStatus, ProjectHealth, ProjectStatus, TaskStatus } from './status';

type Props = { status: PillStatus; label?: string; dot?: boolean; className?: string };

export function StatusPill({ status, label, dot = true, className }: Props) {
  const { t } = useTranslation();
  const tone = STATUS_TONE[status];
  const text = t(`status.${status}`);
  const classes = ['m-pill', `m-pill--${tone}`];
  if (className) classes.push(className);
  return (
    <span className={classes.join(' ')}>
      {dot ? <span className="m-pill__dot" aria-hidden="true" /> : null}
      {label ?? text}
    </span>
  );
}
